import { render, staticRenderFns } from "./DashboardAnalysisFilters.vue?vue&type=template&id=0336e4c4&scoped=true&"
import script from "./DashboardAnalysisFilters.vue?vue&type=script&lang=ts&"
export * from "./DashboardAnalysisFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAnalysisFilters.vue?vue&type=style&index=0&id=0336e4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336e4c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
